module.exports = __webpack_public_path__ + "img/small_xq.1225af1c.png";